function u(s, e, t, l, a, r, i, _) {
  var n = typeof s == "function" ? s.options : s;
  e && (n.render = e, n.staticRenderFns = t, n._compiled = !0), l && (n.functional = !0), r && (n._scopeId = "data-v-" + r);
  var c;
  if (i ? (c = function(o) {
    o = o || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !o && typeof __VUE_SSR_CONTEXT__ < "u" && (o = __VUE_SSR_CONTEXT__), a && a.call(this, o), o && o._registeredComponents && o._registeredComponents.add(i);
  }, n._ssrRegister = c) : a && (c = _ ? function() {
    a.call(
      this,
      (n.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), c)
    if (n.functional) {
      n._injectStyles = c;
      var v = n.render;
      n.render = function(C, p) {
        return c.call(p), v(C, p);
      };
    } else {
      var d = n.beforeCreate;
      n.beforeCreate = d ? [].concat(d, c) : [c];
    }
  return {
    exports: s,
    options: n
  };
}
const m = {
  name: "CpCallout",
  props: {
    charLimit: {
      type: Number,
      default: 256
    },
    note: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    visible: {
      type: Boolean,
      default: !1
    },
    isRead: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["removeCallout", "editCallout", "addCallout", "update:visible"],
  data: () => ({
    localNote: null
  }),
  computed: {
    charsLeft() {
      return this.charLimit - this.inputModel.length;
    },
    charsCountText() {
      const s = Math.abs(this.charsLeft);
      let e = `${s} character`;
      return s !== 1 && (e += "s"), this.limitExceeded && (e += " over limit"), e;
    },
    hasChanges() {
      return this.inputModel && this.inputModel !== this.note;
    },
    limitExceeded() {
      return this.charsLeft < 0;
    },
    inputModel: {
      get() {
        return this.localNote === null ? this.note : this.localNote;
      },
      set(s) {
        this.localNote = s;
      }
    }
  },
  watch: {
    visible(s) {
      s && !this.readonly && this.$nextTick(() => {
        setTimeout(() => {
          const { textarea: e } = this.$refs.calloutInput.$refs;
          e.selectionEnd = e.value.length, e.selectionStart = e.selectionEnd, e.focus();
        }, 100);
      });
    }
  },
  methods: {
    closeCallOut() {
      this.localNote = null, this.$emit("update:visible", !1);
    },
    clearLocalNote() {
      this.localNote = null;
    },
    removeCallOut() {
      this.localNote = null, this.$emit("removeCallout");
    },
    saveCallOut() {
      this.hasChanges && !this.limitExceeded && (this.note ? this.$emit("editCallout", this.localNote) : this.$emit("addCallout", this.localNote));
    }
  }
};
var b = function() {
  var e = this, t = e._self._c;
  return t("TfTooltip", { class: { "is-read": e.isRead }, attrs: { "force-show": e.visible, "show-close": e.visible, options: { placement: "top-start" }, "append-to-body": !1, trigger: "clickToOpen" }, on: { documentClick: e.closeCallOut, hide: e.closeCallOut }, scopedSlots: e._u([{ key: "reference", fn: function() {
    return [e._t("reference")];
  }, proxy: !0 }], null, !0) }, [t("section", { attrs: { "data-test": "callout tooltip" } }, [t("header", [t("h5", [e._v(" Benefit call-out "), e.isRead ? t("span", [e._v(" - read")]) : e._e()])]), e.readonly ? t("p", { domProps: { textContent: e._s(e.note) } }) : [t("ElInput", { ref: "calloutInput", class: { error: e.limitExceeded }, attrs: { role: "textbox", type: "textarea", rows: "6" }, model: { value: e.inputModel, callback: function(l) {
    e.inputModel = l;
  }, expression: "inputModel" } }), t("div", { staticClass: "footer" }, [t("div", { staticClass: "small-text", attrs: { "data-test": "callout word count" } }, [t("div", { staticClass: "word-count", class: { error: e.limitExceeded } }, [e._v(" " + e._s(e.charsCountText) + " ")])]), t("div", { staticClass: "btn-group" }, [e.note ? t("AppButton", { attrs: { "data-test": "delete callout", icon: "fa-solid fa-trash-can", size: "icon", text: "remove callout", type: "danger" }, on: { click: e.removeCallOut } }) : e._e(), t("AppButton", { attrs: { "is-disabled": e.limitExceeded || !e.hasChanges, type: e.limitExceeded ? "danger" : "success", "data-test": "save callout", icon: "fa-solid fa-check", size: "icon", text: "save callout" }, on: { click: e.saveCallOut } })], 1)])]], 2)]);
}, y = [], $ = /* @__PURE__ */ u(
  m,
  b,
  y,
  !1,
  null,
  "8884a884",
  null,
  null
);
const U = $.exports;
const g = {
  name: "CpTableCell",
  props: {
    header: {
      type: Boolean,
      default: !1
    }
  }
};
var T = function() {
  var e = this, t = e._self._c;
  return t(e.header ? "th" : "td", { tag: "component", staticClass: "cp-table__cell", attrs: { "data-test": "table cell" } }, [e._t("default")], 2);
}, w = [], x = /* @__PURE__ */ u(
  g,
  T,
  w,
  !1,
  null,
  "70047cfb",
  null,
  null
);
const f = x.exports, k = {
  name: "CpTableRow"
};
var R = function() {
  var e = this, t = e._self._c;
  return t("tr", { staticClass: "cp-table__row" }, [e._t("default")], 2);
}, O = [], B = /* @__PURE__ */ u(
  k,
  R,
  O,
  !1,
  null,
  null,
  null,
  null
);
const h = B.exports;
const N = {
  name: "CpTable",
  components: { CpTableRow: h, CpTableCell: f },
  props: {
    columns: {
      type: Array,
      required: !0
    },
    rows: {
      type: Array,
      default: () => []
    },
    cssVars: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    computedCssVars() {
      return {
        "--cp-table-columns": `repeat(${this.columns.length}, 1fr)`,
        ...this.cssVars
      };
    }
  }
};
var S = function() {
  var e = this, t = e._self._c;
  return t("table", { staticClass: "cp-table", style: e.computedCssVars }, [t("thead", { staticClass: "cp-table__row" }, [e._t("header"), e._t("column-headers", function() {
    return [t("CpTableRow", { staticClass: "cp-table__column-headers" }, e._l(e.columns, function({ label: l, id: a }) {
      return t("CpTableCell", { key: `col-header-${a}`, attrs: { header: !0 } }, [e._v(" " + e._s(l) + " ")]);
    }), 1)];
  })], 2), t("tbody", { directives: [{ name: "loading", rawName: "v-loading", value: e.isLoading, expression: "isLoading" }], staticClass: "cp-table__body" }, [e._l(e.rows, function(l, a) {
    return [e._t("row", function() {
      return [t("CpTableRow", { key: `row-${l.id}` }, e._l(e.columns, function({ id: r }) {
        return t("CpTableCell", { key: `row-col-${r}` }, [e._v(" " + e._s(l[r]) + " ")]);
      }), 1)];
    }, { row: l, rowIndex: a, columns: e.columns })];
  }), !e.isLoading && !e.rows.length ? e._t("empty", function() {
    return [t("CpTableRow", { staticClass: "cp-table__empty" }, [t("CpTableCell", [e._v("No items to display.")])], 1)];
  }) : e._e()], 2), e.$slots.footer ? t("tfoot", { staticClass: "cp-table__row" }, [e._t("footer")], 2) : e._e()]);
}, L = [], V = /* @__PURE__ */ u(
  N,
  S,
  L,
  !1,
  null,
  null,
  null,
  null
);
const X = V.exports;
const E = {
  name: "CpTableSort",
  components: { CpTableRow: h, CpTableCell: f },
  props: {
    columns: {
      type: Array,
      required: !0,
      validator: (s) => s.every(({ id: e, isSortable: t = !0 }) => typeof e == "string" && typeof t == "boolean")
    },
    sortBy: {
      type: String,
      required: !0
    },
    sortOrder: {
      type: String,
      required: !0,
      validator: (s) => ["asc", "desc"].includes(s)
    }
  },
  emits: ["update:sortBy", "update:sortOrder"],
  methods: {
    changeSort(s, e) {
      if (!e)
        return;
      let t = this.sortOrder;
      this.sortBy === s ? t = this.sortOrder === "asc" ? "desc" : "asc" : t = "desc", this.$emit("update:sortBy", s), this.$emit("update:sortOrder", t);
    }
  }
};
var M = function() {
  var e = this, t = e._self._c;
  return t("CpTableRow", { staticClass: "cp-table__column-headers" }, e._l(e.columns, function({
    label: l,
    id: a,
    isSortable: r = !0,
    sortId: i = a
  }) {
    return t("CpTableCell", { key: `header-col-${a}`, class: {
      sortable: r,
      active: e.sortBy === i
    }, attrs: { "data-test": "sort by" }, nativeOn: { click: function(_) {
      return e.changeSort(i, r);
    } } }, [t("span", [e._v(e._s(l))]), e.sortBy === i ? t("AppIcon", { class: { "fa-flip-vertical": e.sortOrder === "asc" }, attrs: { icon: "fa-solid fa-caret-down" } }) : e._e()], 1);
  }), 1);
}, A = [], F = /* @__PURE__ */ u(
  E,
  M,
  A,
  !1,
  null,
  "2a46f452",
  null,
  null
);
const W = F.exports, j = (s, e) => (t, l) => {
  const a = t[s].toLowerCase(), r = l[s].toLowerCase();
  return a < r ? e === "asc" ? -1 : 1 : a > r ? e === "asc" ? 1 : -1 : 0;
};
const q = {
  __name: "CpTabsVertical",
  props: {
    tabs: {
      type: Array,
      required: !0,
      validator: (s) => s.every(({ id: e, label: t }) => e && t)
    },
    current: {
      type: String,
      default: null
    }
  },
  emits: ["update:current"],
  setup(s, { emit: e }) {
    return { __sfc: !0, emit: e, tabClicked: (l) => {
      e("update:current", l);
    } };
  }
};
var z = function() {
  var e = this, t = e._self._c, l = e._self._setupProxy;
  return t("nav", { staticClass: "cp-tabs" }, e._l(e.tabs, function(a) {
    return t("button", { key: a.id, class: {
      "cp-tabs__tab": !0,
      [`cp-tabs__tab__id-${a.id}`]: !0,
      "cp-tabs__tab--current": a.id === e.current
    }, attrs: { "data-test": `click ${a.id} tab`, type: "button" }, on: { click: function(r) {
      return l.tabClicked(a.id);
    } } }, [e._t("default", function() {
      return [e._v(" " + e._s(a.label) + " ")];
    }, null, a)], 2);
  }), 0);
}, I = [], P = /* @__PURE__ */ u(
  q,
  z,
  I,
  !1,
  null,
  "fb394724",
  null,
  null
);
const D = P.exports, G = {
  install(s, e) {
    var t;
    (t = e.library) == null || t.add();
  }
};
export {
  U as CpCallout,
  G as CpComponents,
  X as CpTable,
  f as CpTableCell,
  h as CpTableRow,
  W as CpTableSort,
  D as CpTabsVertical,
  j as objectSortBy
};
